module.exports = "<ng2-smart-table [nbSpinner]=\"loading\" [settings]=\"settings\" [source]=\"taches\"></ng2-smart-table>"